var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"ui-switch",class:_vm.tone !== 'success' && `ui-switch--${_vm.tone}`,attrs:{"type":"button","role":"switch","aria-checked":String(_vm.value),"aria-label":_vm.label,"title":_vm.title || _vm.label,"disabled":_vm.disabled},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('input', !_vm.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }